export default "__VITE_ASSET__BAH_XNe9__"